<template>
	<component :is="tag" :class="componentClass" class="metrics__metric--percent">
		<dt class="metrics__metric__title" v-html="title"/>
		<div class="metrics__metric__value">
			<dd v-if="amount !== null" class="metrics__metric__value__amount" v-html="amount"/>
			<div v-if="percent && !disabled" class="metrics__metric__value__percent">
				<dd v-html="$present('percent', tweenedValue)"/>
				<svg
					version="2.0" viewBox="0 0 500 500">
					<g
						fill="none" stroke-linecap="round" stroke-linejoin="round"
						stroke-miterlimit="10" stroke-width="20">
						<g stroke="rgb(238, 238, 238)">
							<path
								d="M127.2,419.7C74.7,381.7,40.5,319.8,40.5,250c0-115.7,93.8-209.5,209.5-209.5S459.5,134.3,459.5,250
	c0,69.8-34.2,131.7-86.7,169.7"/>
						</g>
						<g
							:stroke="stroke"
							data-animated-illustration>
							<path
								d="M127.2,419.7C74.7,381.7,40.5,319.8,40.5,250c0-115.7,93.8-209.5,209.5-209.5S459.5,134.3,459.5,250
	c0,69.8-34.2,131.7-86.7,169.7"/>
						</g>
					</g>
				</svg>
			</div>
		</div>
	</component>
</template>
<script>
export default {
	name: "AppMetricPercent",

	data() {
		return {
			played: false,
			tweenedValue: 0,
		};
	},

	props: {
		tag: {
			type: String,
			required: false,
			default() {
				return "dl";
			},
		},
		title: {
			type: String,
			required: false,
			default() {
				return null;
			},
		},
		amount: {
			required: false,
			type: Number,
			default() {
				return null;
			},
		},
		percent: {
			required: false,
			type: Object,
			default() {
				return null;
			},
		},
		round: {
			required: false,
			default() {
				return 0;
			},
		},
	},

	computed: {
		componentClass() {
			return {
				"metrics__metric--progress--disabled": this.disabled,
			};
		},
		disabled() {
			if (!this.percent) {
				return false;
			}
			return isNaN(Number.parseFloat(this.percent.percent));
		},
		color() {
			var percentColors = [
				{pct: 0.0, color: {r: 0x49, g: 0x7D, b: 0xB2}},
				{pct: 100, color: {r: 0xD3, g: 0x50, b: 0x98}}];

			for (var i = 1; i < percentColors.length - 1; i++) {
				if (this.tweenedValue < percentColors[i].pct) {
					break;
				}
			}
			var lower = percentColors[i - 1];
			var upper = percentColors[i];
			var range = upper.pct - lower.pct;
			var rangePct = (this.tweenedValue - lower.pct) / range;
			var pctLower = 1 - rangePct;
			var pctUpper = rangePct;
			var color = {
				r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
				g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
				b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper),
			};
			return "rgb(" + [color.r, color.g, color.b].join(",") + ")";
		},
		stroke() {
			return "rgb(211, 80, 152)";
		},
		paths() {
			return this.$el.querySelectorAll("[data-animated-illustration] *:not(g)");
		},
	},

	methods: {
		setPathOffset(el) {
			el.style["stroke-dashoffset"] = el.dataset.pathLength - el.dataset.pathLength / 100 * this.tweenedValue;
		},
		setPathColor(el) {
			el.style["stroke"] = this.color;
		},
		animatePaths() {
			_.each(this.paths, function (path) {
				this.setPathOffset(path);
				this.setPathColor(path);
			}.bind(this));
		},
		tween(start, end) {
			let frameHandler;

			// Handles updating the tween on each frame.
			const animate = function (currentTime) {
				window.tween.update(currentTime);
				frameHandler = requestAnimationFrame(animate);
			};

			const myTween = new window.tween.Tween({tweeningValue: start})
				.to({tweeningValue: end}, 750)
				.easing(window.tween.Easing.Quintic.Out)
				// Be careful to not to do too much here! It will slow down the app.
				.onUpdate((tween) => {
					this.tweenedValue = tween.tweeningValue.toFixed(this.round);
					if (this.round) {
						let parts = this.tweenedValue.split(".");
						let decimal = parseInt(parts[1]);
						if (!decimal) {
							this.tweenedValue = parseInt(parts[0]);
						}
					}
					this.animatePaths();
				})
				.onComplete(() => {
					// Make sure to clean up after ourselves.
					cancelAnimationFrame(frameHandler);
				})
				// This actually starts the tween.
				.start();

			frameHandler = requestAnimationFrame(animate);
		},
	},

	watch: {
		percentage(newValue, oldValue) {
			this.tween(oldValue, newValue);
		},
	},

	mounted() {
		_.each(this.paths, function (path) {
			let length = path.getTotalLength();
			path.setAttribute("data-path-length", length);
			path.style["stroke-dasharray"] = length;
			path.style["stroke-dashoffset"] = length;
			path.style["stroke"] = this.color;
		}.bind(this));

		setTimeout(function () {
			this.tween(0, this.percent.percent || 0);
		}.bind(this), 500);
	},
};
</script>
<style>
[data-animated-illustration] *:not(g) {
	/*transition: all 750ms cubic-bezier(.42, 0, .58, 1);*/
}
</style>
